'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import { endImpersonation } from './end-impersonation-action';
import { TextButton } from '@tuic/web-compositions/core/TextButton';

export function EndSessionButton() {
  const router = useRouter();

  return (
    <form
      action={async () => {
        await endImpersonation();
        // dirty refresh to force the impersonationBanner to reread cookies
        router.refresh();
      }}
    >
      <TextButton type="submit">End Session</TextButton>
    </form>
  );
}
